'use client';

import { Box, Skeleton } from '@mui/material';

// Matches the authenticated BottomNavigation shape (home, breaking, deposit,
// search, portfolio) — the common case, and the one with the extra floating
// deposit circle that most needs a placeholder to avoid a layout jump.
const TAB_COUNT = 5;
const DEPOSIT_TAB_INDEX = 2;

export const BottomNavigationSkeleton = () => {
  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          display: { xs: 'flex', md: 'none' },
          bottom: '28px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 1150,
          width: 45,
          height: 45,
          borderRadius: '50px',
        }}
      >
        <Skeleton variant="circular" width={45} height={45} />
      </Box>
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
          display: { xs: 'flex', md: 'none' },
          height: 64,
          borderTop: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
          width: '100%',
          maxWidth: '100vw',
          px: 2,
          alignItems: 'center',
          justifyContent: 'space-around',
        }}
      >
        {[...Array(TAB_COUNT)].map((_, i) => (
          <Box
            key={i}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 1,
              flex: 1,
            }}
          >
            {i === DEPOSIT_TAB_INDEX ? (
              // Same-size-as-the-others invisible spacer: the real circle is
              // the separate Portal-rendered element above.
              <Box sx={{ width: 24, height: 24 }} />
            ) : (
              <Skeleton variant="circular" width={24} height={24} />
            )}
            <Skeleton variant="rectangular" width={40} height={10} sx={{ borderRadius: '4px' }} />
          </Box>
        ))}
      </Box>
    </>
  );
};
